$.eachComponent('.contracts-general-values-definition', function(context) {
    $('select[name="fk_contracts_general_values_types"], select[name="options[user_defined_list]"]', context).change(function(){
        $('input[name="reload"]').click();
    });
});


